export default function () {
  return {
    token: '',
    userInfo: {},
    loginParams: {},
    addressInfo: {},
    orderId: '',
    userId: '',
    toLoginPath: '',
    accessStatus: 'DINE_IN',
    storeServes: {},
    scheduled: false, // 是否开启预订单模式
    scheduledTime: 0, // 预订时间
    scheduledEndTime: 0, // 预订时间
    language: '',
    countryCode: '+62',
    countryName: 'Indonesia',
    nearestStatus: false, // 默认不是最近的店铺
    fullDineInTableData: {
      cart: {},
      order: {}
    },
    platVoucher: false,
    showVoucherDialogList: [],
    account: '',
  };
}
